export const itemBadgeStyles = {
  container: {
    background: "green",
    padding: "0 .4rem",
    color: "#fff",
    borderRadius: ".2rem",
    borderTopRightRadius: ".5rem",
    borderBottomRightRadius: "0",
    position: "absolute",
    top: 0,
    right: 0,
  },
};
